var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeInMediaQuery = exports.getResponsiveProp = void 0;

var facepaint_1 = __importDefault(require("facepaint"));

exports.getResponsiveProp = function (_ref) {
  var theme = _ref.theme,
      propName = _ref.propName,
      propValue = _ref.propValue;
  var breakPointList = theme.breakpoints;
  var mediaQuery = facepaint_1.default(breakPointList.map(function (breakPoint) {
    return "@media (min-width: ".concat(breakPoint, ")");
  }));
  return mediaQuery(_defineProperty({}, propName, propValue))[0];
};

exports.mergeInMediaQuery = function (_ref2) {
  var result = _ref2.result,
      propWithMediaQueries = _ref2.propWithMediaQueries;

  if (!propWithMediaQueries) {
    return;
  }

  Object.entries(propWithMediaQueries).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        query = _ref4[0],
        property = _ref4[1];

    if (query.startsWith('@media ')) {
      if (!result[query]) {
        result[query] = {};
      }

      Object.assign(result[query], property);
    } else {
      result[query] = property;
    }
  });
};